document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".adj-swiper-container", {
    slidesPerView: 1.2,
    spaceBetween: 16,
    grabCursor: true,
    navigation: {
      nextEl: ".product-next", 
      prevEl: ".product-prev", 
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        540: { slidesPerView: 1.8 },
        990: { slidesPerView: 3 }
    },
  });
  const swiperCollection = new Swiper(".collection-swiper-container", {
    slidesPerView: 1.8,
    spaceBetween: 16,
    grabCursor: true,
    navigation: {
      nextEl: ".slider--nav-item.next", 
      prevEl: ".slider--nav-item.prev", 
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        540: { slidesPerView: 2.8 },
        990: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
        1400: { slidesPerView: 5 },
    },
  });
  
  const collectionCards = document.querySelectorAll(".collection-card");
  const productSwiper = document.querySelector(".product-swiper");
  const collectionSwiper = document.querySelector(".collection-swiper");
  const productList = productSwiper.querySelector(".product-list");
  const collectionClass = document.querySelector(".collection-class");
  const productClass = document.querySelector(".product-class");
  const resetButton = document.querySelector(".collection-reset-selection");
  const makeNavigation = document.querySelector("#make-navigation");
  let productListContainerWrapperSlider = document.querySelector("#special-product-list-container");
  let makeNavigationBestSellerSlider = document.querySelector(".make-navigation-best-seller-slider");

  const productdomHtmlData = document.querySelector(".product-dom-html-data");
  let productDatas = productdomHtmlData.querySelectorAll(".swiper-slide");
  
  resetButton.addEventListener("click", function () {
    if (window.collectionSwiper) {
      window.collectionSwiper.slideTo(0, 0); // İlk slayta götür
    }

    if (window.productSwiper) {
      window.productSwiper.slideTo(0, 0); // İlk slayta götür
    }

    makeNavigationBestSellerSlider.style.display = "flex";
    collectionClass.style.display = "block";
    productClass.style.display = "none";
    productListContainerWrapperSlider.innerHTML += productListContainerWrapperSlider.innerHTML;
    productListContainerWrapperSlider.innerHTML = "";

  
  });

  collectionCards.forEach((card) => {
    card.addEventListener("click", function (e) {
      

      const collectionHandle = card.getAttribute("data-collection");
     
      
      if(productdomHtmlData) {
       
        
        productDatas.forEach(item => {          
          
          let itemDatasetCollections = item.dataset.collections.split(",");
          
          
          itemDatasetCollections.forEach(el => {
            
            if(el === collectionHandle) {
              
              productListContainerWrapperSlider.appendChild(item);
            }
          })
          
        });

        productClass.style.display = "block";
        collectionClass.style.display = "none";
        makeNavigationBestSellerSlider.style.display = "none"
        
      }

    });
  });

});

